/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
 
  
  $('.Header__MainNav li > a').each(function () {
    var $this = $(this);
    var loc = location.pathname;
    if (loc.replace(/\/[^\/]*\.html$/, '').startsWith($this.attr('href').replace(/\.html$/, ''))) {
      $this.parents("li").last().addClass('is-expanded');
    }
  });
  
      $('.prod_nav_container').on('click','.prod-nav-item', function ( e ) {
//         e.preventDefault();
        $(this).parents('.prod_nav_container').find('.active').removeClass('active').end().end().addClass('active');
    });

});

function adapterProcedure(input) {

    var rtn = WL.Server.invokeHttp(input);
    rtn = JSON.parse(unescape(encodeURIComponent(JSON.stringify(rtn))));
    return rtn;
}